import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from './shared/services/authentication.guard';
import { LoginGuard } from './shared/services/login.guard';

import { LoginComponent } from './login/login.component';
import { CustomersPageComponent } from './pages/customers-page/customers-page.component';
import { CustomerPageComponent } from './pages/customer-page/customer-page.component';
import { RequestsPageComponent } from './pages/requests-page/requests-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', canActivate: [LoginGuard], component: LoginComponent },
  { path: 'customers', canActivate: [AuthenticationGuard], component: CustomersPageComponent },
  { path: 'customers/:id/:page', canActivate: [AuthenticationGuard], component: CustomerPageComponent },
  { path: 'requests/:id', canActivate: [AuthenticationGuard], component: RequestsPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
